import { render } from "./SummaryCards.vue?vue&type=template&id=51b9735d&scoped=true"
const script = {}

import "./SummaryCards.vue?vue&type=style&index=0&id=51b9735d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51b9735d"]])

export default __exports__